import supportPhoto from "assets/img/support-agent.jpg";
import mathieuPhoto from "assets/img/support-mathieu.jpg";
import ibrahimPhoto from "assets/img/support-ibrahim.jpg";

/**
 * Who a support reply is shown as. Picked per message in /bo/support, stored on the message
 * (`agent`), and shown by the widget with that photo and name. Keys mirror SUPPORT_AGENTS in
 * crm-back's supportTicketSchema.ts; `support` is the team, shown as Belinay (the key stays
 * `support`: it is stored on past messages).
 */
export interface SupportAgent {
    key: string;
    name: string;
    photo: string;
    /** Days on duty, 0 = Monday, from SUPPORT_OPEN_HOUR to SUPPORT_CLOSE_HOUR (Paris time) */
    days: number[];
}

export const SUPPORT_AGENTS: SupportAgent[] = [
    { key: "support", name: "Belinay", photo: supportPhoto, days: [0, 1, 2, 3, 4] },
    { key: "mathieu", name: "Mathieu", photo: mathieuPhoto, days: [0, 1, 2] },
    { key: "ibrahim", name: "Ibrahim", photo: ibrahimPhoto, days: [3, 4] },
];

// Messages sent before agents existed carry none: shown as the team
export const supportAgent = (key?: string) => SUPPORT_AGENTS.find((a) => a.key === key) ?? SUPPORT_AGENTS[0];
